// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".X3oPTQdewTY7UsCKUHjd{width:20rem}", "",{"version":3,"sources":["webpack://./src/location/room-management/room-event-manager/date-picker/date-picker.module.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA","sourcesContent":[".host {\n  width: 20rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"host": "X3oPTQdewTY7UsCKUHjd"
};
export default ___CSS_LOADER_EXPORT___;
